import React, { useEffect, useState } from "react";
import "./Loading.css";
import ShortfyLogo from "../../assets/images/Shortfy-Logo.png";

interface LoadingProps {
  message?: string;
  className?: string;
  onRetry?: () => void;
}

const SHOW_DELAY_MS = 700;       // Don't show loader if done before this
const SLOW_TIMEOUT_MS = 1000;   // Show "slow connection" warning after this

const Loading: React.FC<LoadingProps> = ({
  message = "Loading...",
  className = "",
  onRetry,
}) => {
  const [visible, setVisible] = useState(false);
  const [isSlow, setIsSlow] = useState(false);

  useEffect(() => {
    // Only show the loader if loading takes longer than 700ms
    const showTimer = setTimeout(() => setVisible(true), SHOW_DELAY_MS);

    // Show "slow connection" warning after 10s
    const slowTimer = setTimeout(() => setIsSlow(true), SLOW_TIMEOUT_MS);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(slowTimer);
    };
  }, []);

  // Don't render anything until threshold is crossed
  if (!visible) return null;

  return (
    <div className={`loading-overlay ${className}`}>
      <div className="loading-card">

        {/* Branding */}
        <div className="loading-brand">
          <img
            src={ShortfyLogo}
            alt="Shortfy Logo"
            className="loading-logo-img"
          />
        </div>

        {/* Spinner */}
        <div className="loading-spinner-wrapper">
          <div className="loading-spinner" />
        </div>

        {/* Message */}
        {!isSlow ? (
          <p className="loading-message">{message}</p>
        ) : (
          <div className="loading-slow">
            <p className="loading-slow-message">
              ⚠️ Connection is slow...
            </p>
            {onRetry && (
              <button className="loading-retry-btn" onClick={onRetry}>
                Retry
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Loading;